<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import BaseForm from './base-form';

export default {
    mixins: [BaseForm],
    props: [
        'openModal',
        'closeModal',
        'isModalOpen'
    ],
    data: () => ({
        communities: []
    }),
    created() {
        this.getCommunities();
    },
    mounted() {
        this.boot();
    },
    methods: {
        getCommunities() {
            this.showForm = false;
            Tortilla.Xhr.get('api/form/communities').then((res) => {
                this.communities = res.data
                this.showForm = true;
            });
        },
        submit(event) {
            this.beforeSubmit();
            this.recaptchaSubmit().then(() => {
                this.form
                .post(event.target.action, {
                    ...this.fields, ...this.persistents
                })
                .then((result) => this.success(result, event))
                .catch((err) => this.failure());
            });
        }
    }
};
</script>
